import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertDialogData } from 'src/app/pos/models/alert.model';

@Component({
  selector: 'app-default-alert',
  templateUrl: './default-alert.component.html',
  styleUrls: ['./default-alert.component.scss'],
})
export class DefaultAlertComponent implements OnInit {
  titleText: string[];
  constructor(
    public dialogRef: MatDialogRef<DefaultAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlertDialogData
  ) {}

  ngOnInit(): void {
    this.data.mode ||= 'error';

    this.titleText = this.data.title.split('|');

    if (this.data.timeout) {
      setTimeout(() => {
        this.dialogRef.close(true);
      }, this.data.timeout);
    }
  }

  close(): void {
    this.dialogRef.close(false);
  }

  submit(): void {
    this.dialogRef.close(true);
  }
}
